import { combineReducers } from 'redux';

import data from './data';
import legacy from './legacy.find';
import ui from './ui';

/**
 * @typedef {{
 *   data: import('./data').GroupDataEntity,
 *   ui: import("./ui").GroupUIReducer,
 *   legacy: import('./legacy.find').GroupFindByNameReducer,
 * }} GroupsReducer
 */

export default combineReducers({
  data,
  ui,
  legacy,
});
